<template>
    <div class="panel sluzebka_inside col-lg-8 col-xl-9 col-sm-8 col-xs-12">
        <div class="panel-hdr">
            <h2>Превью
                <sup>
                    <span class="badge badge-warning ml-2">
                        {{ out_number }}
                    </span>
                </sup>
            </h2>
            
            <div class="panel-toolbar ml-2">
                <h5 class="m-0">
                    <span class="badge badge-primary fw-400 l-h-n cursor-pointer hidden-md-down" v-on:click="go_back">
                       Повернутися назад
                    </span>
                </h5>
            </div>
        </div>
        
        <div class="panel-container show">
            <div class="panel-content">
                <!-- head_menu -->
                <div class="head_mem">
                    <div class="head">
                        <div class="logo">
                            <div class="img"></div>
                            <div class="clr"></div>
                        </div>
                    </div>
                    
                    <div class="organization_section" v-if="obj_to_null(organization)">
                        <div class="tov">
                            <div class="sluz_number">
                                <div class="out_numb text-right small">{{ out_number }}</div>
                            </div>
                        </div>
                        
                        <div class="clr"></div>
                        <div class="title tov_new">
                            <h1>{{ organization.title }}</h1>
                        </div>
                    </div>
                    
                    <div class="tov w-50 width-mobile-full float-right" v-if="obj_to_null(recipient)">
                        <div class="to">
                            <div class="dolzn border border-left-0 border-right-0 border-top-0 border-dark mt-2">
                                {{ recipient.dolznost }}
                            </div>
                            <div class="fio border border-left-0 border-right-0 border-top-0 border-dark mt-2">
                                {{ recipient.fio }}
                            </div>
                        </div>
                    </div>
                    <div class="clr"></div>
                </div>
                
                <!-- body -->
                <div class="body_sluz">
                    <component v-bind:is="cur_addon" ></component>
                </div>
            </div>
        
        </div>
        <div
            class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 mb-2 mt-3 pt-3 row justify-content-between">
            <div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3">
                <button class="btn btn-lg btn-block btn-outline-success waves-effect waves-themed"
                        :disabled="is_save_inactive"
                        v-on:click="save('simple')">
                    <span class="fal fa-download mr-1"></span>
                    На Погодження
                </button>
            </div>
            
            <div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3">
                <button class="btn btn-lg btn-block btn-outline-info waves-effect waves-themed"
                        :disabled="is_save_inactive"
                        v-on:click="save('pre')">
                    <span class="fal  fa-eject mr-1"></span>
                    В Чернетку
                </button>
            </div>
            
            <div class="col-xs-12 col-lg-4 btn-block col-sm-4 col-xl-3 mt-3">
                <button class="btn btn-lg btn-block btn-outline-primary waves-effect waves-themed" v-on:click="go_back">
                    Повернутися назад
                </button>
            </div>
        
        </div>
    </div>
</template>

<script>



import standart from "./addon/standart.vue";
import kadru from "./addon/kadru/kadru.vue";
import bill from "./addon/bill/bill.vue";
import land from "./addon/land/land.vue";
import tender from "./addon/tender/tender.vue";
import dogovor from "./addon/dogovor/dogovor.vue";
import trip from "./addon/trip/trip.vue";
import vacation from "./addon/vacation/vacation.vue";
import fire from "./addon/fire/fire.vue";
import order from "./addon/order/order.vue";
import inbox_imc from "./addon/inbox/inbox_imc.vue";
import parts_reserv from "./addon/parts/parts_reserv/parts_reserv.vue";
import parts from "./addon/parts/parts/parts.vue";

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});

export default {
    name: "mem_preview_left",
    components: {
        standart,
        kadru,
        bill,
        land,
        tender,
        dogovor,
        trip,
        vacation,
        fire,
        order,
        inbox_imc,
        parts_reserv,
        parts
    },
    
    data: function data() {
        return {
            cur_date: '',
            is_save_inactive: false
        };
    },
    
    created: function created() {
        this.srv_time();
    },
    
    methods: {
        go_back: function go_back() {
            this.$store.dispatch('memorandum_create/SET_CURRENT_STEP', 'menu_active');
        },
        
        srv_time: function srv_time() {
            var $this = this;
            this.curdate('d.m.Y', function (res) {
                if (myapp_config.debugState)
                    console.log("%c|___IMC SRV DATE", "color: #ffc241", res);
                $this.cur_date = res;
            });
        },
        
        async save(type) {
            
            let send_form =   this.send_form;
            send_form.save_type = type;
           
            console.log("%c|___MEMORANDUM try_save...", "color: #fd3995", send_form);
            this.is_save_inactive = true;
            let act_mem_u = this.active_mem.cur_user;
            
            IMC_CORE.showloading();
            api.put('/memorandum',send_form).then(({data}) => {
                
                this.is_save_inactive = false;
                
                if (data.status == "operation_success") {
                    IMC_CORE.hideloading();
                    IMC_CORE.snackbar('Успішно створенно')
                }
                
                if (act_mem_u.id != "831") {
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
            }).catch(({response}) => {
                console.log("%c|___MEMORANDUM err_save...", "color: #fd3995", response);
                IMC_CORE.hideloading();
                this.is_save_inactive = false;
                EventBus.$emit('show_toast', {err: "CODE:" + response.status + " " + response.data.message, type: "danger", title: response.data.status})
            });
        },
    },
    
    computed: {
        
        ...mapFields([
            'active_memorandum'
        ]),
        
        active_mem() {
            return this.active_memorandum;
        },
        
        organization: function organization() {
            return this.active_memorandum.organization;
        },
        
        out_number: function out_number() {
            return 'Вих.№ ' + this.organization.code + this.recipient.code + "-01- від " + this.cur_date;
        },
        
        recipient: function recipient() {
            
            if(this.active_memorandum.recipient.hasOwnProperty('recipient_data')) {
                return this.active_memorandum.recipient.recipient_data;
            }
            
            return {
                'dolznost' : "",
                "fio" : "",
            };
        },
        
        send_form() {
            let form = {
                addon_data: this.addon_data,
                quest_route: this.quest_route,
                files: this.active_mem.files,
                quest_data: this.active_mem.form,
                is_dir_active: this.active_mem.is_dir_active,
                
                texts: {
                    title: this.active_mem.title,
                    result: this.active_mem.result,
                    preamblua: this.active_mem.preamblua,
                    problem: this.active_mem.problem,
                    reason_number: this.active_mem.reason_number,
                    out_number: this.out_number
                },
                
                users: {
                    adjust_before : this.active_mem.adjust_added,
                    adjust_after   : this.active_mem.adjust_added_after,
                    
                    isp: this.active_mem.isp,
                    rec: this.active_mem.recipient
                },
            };
            
            if (this.active_mem.adv_body !== undefined) {
                if (this.active_mem.adv_body === true) {
                    form.addon_name_adv = 'dima';
                    form.addon = {};
                    try {
                        form.addon = this.active_addon_obj.return_data_form();
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
            return form;
        },
        
        addon_data() {
            try {
                return this.active_addon_obj.return_data;
            } catch (e) {
                return {};
            }
        },
        
        active_addon_obj() {
            let i;
            let add = this.cur_addon;
            
            if (add != '') {
                let comp = this.$options.components[add];
                if (comp != undefined) {
                    for (i = this.$children.length - 1; i >= 0; i -= 1) {
                        if (this.$children[i].$options._componentTag === add) {
                            return this.$children[i];
                        }
                    }
                }
            }
            
            if (this.cur_addon == 'dima') {
                if (myapp_config.debugState)
                    console.log("%c|___MEMORANDUM CUSTOM BODY...", "color: #fd3995",this.current_addon );
                
                for (i = this.$children.length - 1; i >= 0; i -= 1) {
                    if (this.$children[i].$options._componentTag === "dima") {
                        return this.$children[i];
                    }
                }
            }
            
            return null;
            
        },
        
        cur_addon() {
            let addon = this.active_memorandum.form.addon;
            console.log(this.active_memorandum);
            if(addon.length > 0) {
                return addon;
            }
            
            return "standart";
        },
    }
}

</script>

<style scoped>
.body_sluz {
    clear: both;
}
</style>
